import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ContentBaseComponent } from '@xanadu/core';
import { Register } from '@xanadu/core';
import { InputConstant } from '@xanadu/input';
import { Content, PublishData } from '@xanadu/model';
@Component({
    selector: 'app-content-panel',
    templateUrl: './content-panel.component.html',
    styleUrls: ['./content-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('content-panel')
export class ContentPanelComponent extends ContentBaseComponent {
    public tabContent = { caption: 'Content', active: true, hidden: false };
    public tabPublish = { caption: 'Publish', active: false, hidden: false };

    protected override setup(content: Content): void {
        super.setup(content);

        this.tabs = [
            this.tabContent, this.tabPublish
        ];
        this.tabSelected = this.tabContent;
    }

    protected override load(content: Content, form: any): string | undefined {
        super.load(content, form);

        const { publish, ...rest } = form;
        content.publish = new PublishData(publish);
        content.data = rest;
        Object.keys(content.data).forEach(key => {
            if (key.startsWith(InputConstant.ignorePrefix)) {
                delete content.data[key];
            }
        });
        return;
    }
}
